import { MaintenanceAdvancedFiltersDictionaries } from '@hkm/components/Maintenance/shared/filters/maintenanceAdvancedFiltersDictionaries';
import { Dictionary } from '@hkm/shared/dictionaries/dictionary';

export const MaintenanceDashboardDictionaries: Set<Dictionary> = new Set<Dictionary>(MaintenanceAdvancedFiltersDictionaries)
  .add(Dictionary.Room)
  .add(Dictionary.RoomStatus);



// WEBPACK FOOTER //
// ./src/components/Maintenance/shared/config/maintenanceDashboardDictionaries.ts